module.exports = __webpack_public_path__ + "img/expense.b3bf06b9.jpg";